module.exports = __webpack_public_path__ + "img/received.19d55fdf.svg";